import {h, Fragment} from "preact"
import Product from './Product';
import { useAppState } from '@nosto/preact';
import { useEffect } from 'preact/hooks';

const getCurrentCollectionDiscount = () => {
    var cookieValue = document.cookie.replace(/(?:(?:^|.*;\s*)affiliate_coupon\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    const { discountCode, discountTag, collectionId, discountId } = cookieValue && JSON.parse(cookieValue)
    const collectionDiscount = discountCode && collectionId && discountId && discountTag
    return collectionDiscount
}

export default ({ isCategorySelected }) => {
    const { response: { products, query } } = useAppState();

    const shouldShowNewSearch = window.cj.nosto.newSearchFeatureEnabled && !isCategorySelected

    // If query is empty then it's a collection
    const collectionDiscountTag = !query ? getCurrentCollectionDiscount() : ''

    const productIds = products.hits.map((hit) => hit.productId).join("--");
    useEffect(() => {
        // Products to display changed, if the modal is open, close it.
        // This is a side-effect of modifying filters or range facets
        // hooking into cratejoy `window.app` functionality
        app?.modal?.close();
    }, [productIds]);

    return (
        <>
            {shouldShowNewSearch ?
                (<>
                    <div id="plp-main-products-grid ns-grid-cols-3" class='search-main-grid'>
                        {products.hits.map((hit, index) => {
                            return <Product product={hit} key={hit.productId || index} collectionDiscountTag={collectionDiscountTag} />
                        })}
                    </div>
                </>) : (
                    <div id="plp-main-products-grid">
                        {products.hits.map((hit, index) => {
                            return <Product isCategorySelected={isCategorySelected} product={hit} key={hit.productId || index} collectionDiscountTag={collectionDiscountTag} />
                        })}
                    </div>
                )}

        </>
    )
}
